import React, { useState } from "react";
import { useHistory } from "react-router";
import validateEmail from "../../hooks/emailValidator";
import validatePassword from "../../hooks/passwordValidator";
import useForm from "../../hooks/useForm";
import Loader from "../../PhylloConnectComponents/CommonComponents/FullScreenLoader";
import { signup } from "../../utils/apiHelperInternal";
import cross_icon from "../../assets/images/cross-icon.svg";
import back_icon from "../../assets/images/Back_arrow.svg";
import LabelledInput from "../../PhylloConnectComponents/CommonComponents/LabelledInput/LabelledInput";
import "./Signup.scss";
import { Checkbox } from "@mui/material";

const ERROR_COLOR = "#AF5454";
function Signup({ close_card }) {
  const history = useHistory();
  const [validationError, setValidationError] = useState({});
  const [errorMessage, setErrorMsg] = useState("");
  const initialFormData = { email: "", password: "" };
  const [checkbox, setCheckbox] = useState(false);
  const [checkboxError, setCheckboxError] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const formValidations = [
    ({ email }) => {
      return (
        validateEmail(email) || {
          email: "Please enter a valid email.",
        }
      );
    },
    ({ password }) => {
      return (
        validatePassword(password) || {
          password: "Password should be at least 8 characters",
        }
      );
    },
  ];
  const {
    values: credentials,
    setFormData: setCredentials,
    validateFormData,
  } = useForm(initialFormData, formValidations);

  const navigateToNextPage = () => {
    return history.push("/connect");
  };

  const handleSubmitSignup = async (e) => {
    e.preventDefault();
    const validationError = validateFormData();
    const errorKeys = Object.keys(validationError);
    if (errorKeys.length > 0) {
      const errorMessage = validationError[errorKeys[0]];
      setErrorMsg(errorMessage);
      setValidationError({ [errorKeys[0]]: errorMessage });
      return;
    }
    if (checkbox) {
      setCheckboxError(true);
      return;
    }
    try {
      setErrorMsg("");
      setValidationError({});
      setIsLoader(true);
      const data = await signup({
        email_id: credentials.email,
        password: credentials.password,
      });
      if (data.phyllo_user_id) {
        let userId = data.phyllo_user_id;
        sessionStorage.setItem("PHYLLO_USERID", userId);

        navigateToNextPage();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {isLoader ? (
        <Loader />
      ) : (
        <div className="card-container" style={(validationError.email || validationError.password) && { height: "462px" }}>
          <div className="card-content">
            <div className="card_right_icon">
              <img
                src={cross_icon}
                alt="cross_icon"
                onClick={() => close_card(false)}
              />
            </div>
            <div className="card_left_icon">
              <img
                src={back_icon}
                alt="back_icon"
                onClick={() => close_card(false)}
              />
            </div>
            <div>
              <h1 className="card-heading">Sign up</h1>
            </div>
            <form>
              <div className="input-container">
                <LabelledInput
                  name="email"
                  placeholder="Enter your email"
                  label={"Email"}
                  errorMsg={validationError.email && errorMessage}
                  onChange={setCredentials}
                  style={validationError.email && { borderColor: ERROR_COLOR }}
                />
                <LabelledInput
                  name="password"
                  placeholder="at least 8 characters"
                  label={"Password"}
                  errorMsg={validationError.password && errorMessage}
                  type="password"
                  onChange={setCredentials}
                  style={
                    validationError.password && { borderColor: ERROR_COLOR }
                  }
                />
              </div>
              <div className="footer-description">
                <p className="checkboxText">
                  {" "}
                  {/* <input
                    defaultChecked={true}
                    type={"checkbox"}
                    onClick={() => setCheckbox(!checkbox)}
                  /> */}
                  <div className="checkbox" style={checkbox ? { backgroundColor:"#FFF" , border:"2.3px solid #2262ED" ,height:"22.6px" , width:"22.6px" }: {border:"2.3px solid #FFF"}} >
                    <Checkbox
                      iconStyle={{ fill: 'white' }}
                      inputStyle={{ color: 'white' }}
                      style={{ color: 'white' }} 
                      defaultChecked={true} 
                     onClick={() => setCheckbox(!checkbox)}
                      />
                      
                  </div>
                  <p  >
                    By clicking on “Continue” you agree to{" "}
                    <a
                      href="https://getphyllo.com/privacy-policy.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {" "}
                      Phyllo’s End User Privacy Policy.
                    </a>
                  </p>
                </p>
              </div>
              <div>
                <button
                  type="submit"
                  className="footer-button"
                  onClick={handleSubmitSignup}
                  disabled={
                    !credentials.password || !credentials.email || checkbox
                  }
                  style={
                    credentials.password && credentials.email && !checkbox
                      ? {}
                      : { opacity: "60%" }
                  }
                >
                  Sign up
                </button>
              </div>
            </form>
          </div>
        </div >
      )
      }
    </>
  );
}
export default Signup;
